import styles from './Sidebar.module.css';
import { useCallback, useEffect, useRef, useState } from 'react';
import { sidebarRoutes, sidebarAuthRoutes } from 'router/sidebar'
import "@fontsource/roboto"
import { FiMenu, FiX } from "react-icons/fi";
import ItemWithIcon from './ItemWithIcon';
import { useDispatch, useSelector } from 'react-redux';
import { setSidebarStatus } from 'redux/slice/sidebarSlice'
import { useDeviceType } from 'components/hooks/useDeviceType';
import { useLocation } from 'react-router-dom';
import OAuthService from 'services/OAuthService';
import LogoWithSkeleton from '../skeleton/LogoWithSkeleton';


const Sidebar = () => {
    const [links, setLinks] = useState([])
    const refToggle = useRef(null)
    const refNavigation = useRef(null)
    const listRef = useRef(null)
    const isOpen = useSelector(state => state.sidebar.isActive)
    const sidebarItemName = useSelector(state => state.sidebarItem.item)

    const dispatch = useDispatch()


    function openAndCloseSidebar() {
        const toggleClassList = refToggle.current.classList
        const navigationClassList = refNavigation.current.classList
        if (isOpen) {
            toggleClassList.add(styles.active)
            navigationClassList.add(styles.active)
        }
        else {
            toggleClassList.remove(styles.active)
            navigationClassList.remove(styles.active)
        }
    }

    useEffect(() => {
        openAndCloseSidebar()
    }, [isOpen])

    const activate = useCallback(() => {
        dispatch(setSidebarStatus(!isOpen))
    }, [dispatch, isOpen])


    function updateLinks() {
        const userInfo = OAuthService.decryptedSync('userData')
        const { command } = OAuthService.decryptedSync('command')
        setLinks(sidebarRoutes.map((item, i) => {
            const canAccess =
                (item.rights.private === false) ||
                (item.rights.private === true && userInfo?.user) ||
                (item.rights.command === true && command) ||
                (item.rights.jury === true && userInfo?.part?.id > 2) ||
                (item.rights.admin === true && (userInfo?.part?.id > 4 || userInfo?.superUser === true))

            // Определяем маршрут: если есть функция getRoute, используем её, иначе используем name
            const routeName = item.getRoute ? item.getRoute(userInfo) : item.name;

            return canAccess ? (
                <ItemWithIcon key={i} title={item?.title} Icon={item?.icon} name={routeName}>
                    {item.title}
                </ItemWithIcon>
            ) : null;
        }));
    }


    useEffect(() => {
        updateLinks()
    }, [localStorage.getItem('userData'), localStorage.getItem('command'), sidebarItemName])

    useEffect(() => {
        const list = listRef?.current?.children
        for (let i = 0; i < list.length; i++) {
            list[i].onclick = function () {
                let j = 0;
                while (j < list.length) {
                    list[j++].className = styles.sidebarList;
                }
                try {
                    list[i].className = `${styles.sidebarList} ${styles.active}`;
                } catch (error) {
                    // console.log('sidebarError :', error);
                }
            }
        }
    }, [listRef?.current?.children])

    const device = useDeviceType()
    const location = useLocation()
    const [innerWidth, setInnerWidth] = useState(window.innerWidth)
    const navBarPaths = ['admin', 'profile', 'team-grade-page', 'main']

    const authItem = (i) => <ItemWithIcon onClick={updateLinks} newPageTitle={sidebarAuthRoutes[i]?.newPageTitle} title={sidebarAuthRoutes[i]?.title} Icon={sidebarAuthRoutes[i]?.icon} name={sidebarAuthRoutes[i].name}>{sidebarAuthRoutes[i].title}</ItemWithIcon>

    const getSidebarWidth = () => {
      if (device === 'phone') {
          return '4vw'
            // if (navBarPaths.some(element => location.pathname.includes(element))) {
            //     return 'calc(var(--navbar-height) + 3px)'
            // } else {
            //     return '4vw'
            // }
        } else if (device === 'table') {
            return '9.795vw'
        } else {
            if (innerWidth > 1281) {
                return '0.795vw'
            }
            return '6.795vw'
        }
    }

    useEffect(() => {
        const handleResize = () => setInnerWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    // Закрытие сайдбара при клике вне его области на мобильных устройствах
    useEffect(() => {
        if (device !== 'phone' || !isOpen) return

        const handleClickOutside = (event) => {
            if (
                refNavigation.current &&
                !refNavigation.current.contains(event.target) &&
                refToggle.current &&
                !refToggle.current.contains(event.target)
            ) {
                dispatch(setSidebarStatus(false))
            }
        }

        // Добавляем обработчик с небольшой задержкой, чтобы избежать закрытия при открытии
        const timeoutId = setTimeout(() => {
            document.addEventListener('click', handleClickOutside)
        }, 100)

        return () => {
            clearTimeout(timeoutId)
            document.removeEventListener('click', handleClickOutside)
        }
    }, [device, isOpen, dispatch])

    return (
        <aside className={styles.sidebarNavigation} ref={refNavigation}>
            <div className={styles.sidebarIcon}>
                <LogoWithSkeleton
                    skeletonWidth="7vw"
                    skeletonHeight="7vw"
                    skeletonShape="circle"
                />
            </div>
            <div className={styles.toggle} ref={refToggle} onClick={activate} style={{
                top: getSidebarWidth()
            }}>
                {isOpen ? <FiX className={`${styles.close} ${styles.toggleButton}`} />
                    : <FiMenu className={`${styles.open} ${styles.toggleButton}`} />}
            </div>
            <ul ref={listRef} className={styles.sidebarList}>
                {links}
                {localStorage.getItem('userData') ? authItem(1) : authItem(0)}
            </ul>
        </aside>
    );
}

export default Sidebar;
